import React from "react";
import { EditIcon } from "../../Primitives";
import { useTableActionIconStyle } from "./table-action-icons.style";

export const EditItemTableIcon: React.FC<{ isDisabled: boolean }> = ({ isDisabled }) => {
  const { small, greenFill, animatedBorder, disabled } = useTableActionIconStyle();
  const classNames = [small, animatedBorder];

  if (isDisabled) {
    classNames.push(disabled);
  } else {
    classNames.push(greenFill);
  }

  return (
    <div className={classNames.join(" ")}>
      <EditIcon svgColor="white" style={{ flex: 1, padding: "2px" }} />
    </div>
  );
};
